var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.55176 1.58154H15.0518C15.466 1.58154 15.8018 1.91733 15.8018 2.33154V16.689C15.8018 16.8961 15.6338 17.0641 15.4268 17.0641C15.3563 17.0641 15.2873 17.0441 15.2276 17.0067L9.80176 13.605L4.37595 17.0067C4.20048 17.1167 3.96905 17.0637 3.85904 16.8882C3.82161 16.8285 3.80176 16.7595 3.80176 16.689V2.33154C3.80176 1.91733 4.13755 1.58154 4.55176 1.58154Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default __webpack_public_path__ + "static/media/SaveIcon.c6e9e2ac6b6fdf1f61701f0e8e77c224.svg";
export { ForwardRef as ReactComponent };